module.exports = __webpack_public_path__ + "static/media/spinner.0c194e03.gif";